export default __webpack_public_path__ + "static/media/trace_image.f5837d39.jpg";